import { supabase } from '../lib/supabase';

const appointmentService = {
  async getAppointments(userId) {
    if (!userId) return { data: [], error: null };
    const { data, error } = await supabase?.from('appointments')?.select('*')?.eq('user_id', userId)?.eq('status', 'scheduled')?.gt('appointment_date', new Date()?.toISOString())?.order('appointment_date', { ascending: true })?.limit(3);
    return { data: data || [], error };
  },

  async createAppointment(userId, appointmentData) {
    if (!userId) return { data: null, error: new Error('User not authenticated') };
    const { data, error } = await supabase?.from('appointments')?.insert({
        user_id: userId,
        doctor_name: appointmentData?.doctorName,
        specialty: appointmentData?.specialty,
        appointment_date: appointmentData?.appointmentDatetime,
        location: appointmentData?.location,
        notes: appointmentData?.notes,
        status: 'scheduled',
        reminder_7day_sent: false,
        reminder_1day_sent: false,
        reminder_2hour_sent: false
      })?.select()?.single();
    return { data, error };
  },

  async updateAppointment(appointmentId, userId, appointmentData) {
    if (!userId) return { data: null, error: new Error('User not authenticated') };
    const { data, error } = await supabase?.from('appointments')?.update({
        doctor_name: appointmentData?.doctorName,
        specialty: appointmentData?.specialty,
        appointment_date: appointmentData?.appointmentDatetime,
        location: appointmentData?.location,
        notes: appointmentData?.notes,
        updated_at: new Date()?.toISOString()
      })?.eq('id', appointmentId)?.eq('user_id', userId)?.select()?.single();
    return { data, error };
  },

  async deleteAppointment(appointmentId, userId) {
    if (!userId) return { error: new Error('User not authenticated') };
    const { error } = await supabase?.from('appointments')?.delete()?.eq('id', appointmentId)?.eq('user_id', userId);
    return { error };
  },

  async getUpcomingCount(userId) {
    if (!userId) return 0;
    const { count, error } = await supabase?.from('appointments')?.select('*', { count: 'exact', head: true })?.eq('user_id', userId)?.eq('status', 'scheduled')?.gt('appointment_date', new Date()?.toISOString());
    return error ? 0 : (count || 0);
  },

  async getNearestAppointment(userId) {
    if (!userId) return null;
    const { data, error } = await supabase?.from('appointments')?.select('*')?.eq('user_id', userId)?.eq('status', 'scheduled')?.gt('appointment_date', new Date()?.toISOString())?.order('appointment_date', { ascending: true })?.limit(1)?.maybeSingle();
    return error ? null : data;
  },

  async getLatestSymptomNotes(userId) {
    if (!userId) return '';
    const { data, error } = await supabase?.from('symptom_entries')?.select('notes, other_symptom_text, symptom_categories')?.eq('user_id', userId)?.order('created_at', { ascending: false })?.limit(1)?.maybeSingle();
    if (error || !data) return '';
    const parts = [];
    if (data?.symptom_categories?.length) {
      parts?.push(`Recent symptoms: ${data?.symptom_categories?.join(', ')}`);
    }
    if (data?.notes) parts?.push(data?.notes);
    if (data?.other_symptom_text) parts?.push(data?.other_symptom_text);
    return parts?.join('. ');
  }
};

export default appointmentService;
